import { render, staticRenderFns } from "./TipoDocumentos.vue?vue&type=template&id=6aafcef3&scoped=true&"
import script from "./TipoDocumentos.vue?vue&type=script&lang=js&"
export * from "./TipoDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aafcef3",
  null
  
)

export default component.exports